/**
 * This module contains the [[Show]] helper component used to conditionally render HTML.
 */

/***/

import View from '../core/view/View';
import Model from '../core/model/Model';
import { node } from '../core/node/Node';

/**
 * A helper view that renders the contents of its node into the DOM only if some condition is true.
 *
 * ### Basic usage:
 *
 * ```html
 * <div view="show" if="[[someBooleanCondition]]">
 *   This is rendered only if `someBooleanCondition` evaluates to true.
 * </div>
 * ```
 *
 * For this to work, you must have previously registered the component under the key `show`.
 * For example:
 *
 * ```typescript
 * import Show from '.../components/Show';
 * ...
 * scan(document.body, { 'show': Show }, ...otherViewRegistrations);
 * ```
 */
export default class Show extends View<ShowModel> {

	private placeholder:Comment;

	constructor( ) {
		super( { template:'', data:new ShowModel( { if:true } ) } );

		this.placeholder = document.createComment('');

		this.template.dataFactory = () => {
			return this.parent.data;
		}
	}

	init() {
		this.checkVisibility();

		this.data.change.filter( c => c.name == 'if' ).subscribe( this.onModelChange.bind( this ) );
	}

	onModelChange() {
		this.checkVisibility();
	}

	checkVisibility() {
		if( this.data.if && this.placeholder.parentNode ) node( this.placeholder ).replace( this.node );
		if( !this.data.if && this.node.parentNode ) node( this.node ).replace( this.placeholder );
	}
}


/** @ignore */
class ShowModel extends Model {
	if:boolean;
}
